/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface FinancingSourcesOwnFundsVariantsCopyCreate$Params {
  id: string;
}

export function financingSourcesOwnFundsVariantsCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesOwnFundsVariantsCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesOwnFundsVariantsCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

financingSourcesOwnFundsVariantsCopyCreate.PATH = '/api/financing_sources/own_funds_variants/copy/{id}/';
